module.exports = __webpack_public_path__ + "img/img28.121d1ac8.svg";